import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "100",
  height: "100",
  viewBox: "0 0 100 100",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", { "clip-path": "url(#clip0_9001_7715)" }, [
      _createElementVNode("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M0 50C0 22.3791 22.3966 0 50 0C67.9677 0 83.7155 9.47678 92.5286 23.6899V10.3449C92.5286 9.19436 93.4613 8.26162 94.6119 8.26162C95.7625 8.26162 96.6953 9.19436 96.6953 10.3449V30.1725C96.6953 31.3231 95.7625 32.2559 94.6119 32.2559H93.9014H74.7843C73.6337 32.2559 72.701 31.3231 72.701 30.1725C72.701 29.0219 73.6337 28.0892 74.7843 28.0892H90.2703C82.4973 13.8368 67.3777 4.16667 50 4.16667C24.6968 4.16667 4.16667 24.6812 4.16667 50C4.16667 75.3027 24.6973 95.8333 50 95.8333C75.3188 95.8333 95.8333 75.3032 95.8333 50C95.8333 48.8494 96.7661 47.9167 97.9167 47.9167C99.0673 47.9167 100 48.8494 100 50C100 77.6034 77.6209 100 50 100C22.3961 100 0 77.6039 0 50ZM50 16.523C51.1506 16.523 52.0833 17.4557 52.0833 18.6063V44.9252C54.2965 45.6095 56.0431 47.3559 56.7277 49.5689H73.1313C74.2819 49.5689 75.2147 50.5017 75.2147 51.6523C75.2147 52.8029 74.2819 53.7356 73.1313 53.7356H56.7277C55.8396 56.6068 53.1638 58.6926 50.0008 58.6926C46.1126 58.6926 42.9606 55.5406 42.9606 51.6524C42.9606 48.4897 45.046 45.8142 47.9167 44.9257V18.6063C47.9167 17.4557 48.8494 16.523 50 16.523ZM52.8737 51.5879C52.873 51.6093 52.8727 51.6307 52.8727 51.6523C52.8727 51.6738 52.873 51.6953 52.8737 51.7167C52.8395 53.274 51.5664 54.5259 50.0008 54.5259C48.4138 54.5259 47.1273 53.2394 47.1273 51.6524C47.1273 50.0653 48.4138 48.7788 50.0008 48.7788C51.5663 48.7788 52.8394 50.0306 52.8737 51.5879Z",
        fill: "#42BAC1"
      })
    ], -1),
    _createElementVNode("defs", null, [
      _createElementVNode("clipPath", { id: "clip0_9001_7715" }, [
        _createElementVNode("rect", {
          width: "100",
          height: "100",
          fill: "white"
        })
      ])
    ], -1)
  ])))
}
export default { render: render }